import ExamMasterList from "../components/ExamMasterList";

export default function MasterJasa() {
    return (
        <ExamMasterList
            kind="jasa"
            title="Master Jasa Tindakan"
            subtitle="Kelola daftar jasa tindakan beserta unit cost dan harga jual."
            testidPrefix="jasa"
        />
    );
}
